/* eslint-disable react/prop-types */
import classes from './index.module.css';

export const PageTitle = ({ title, subTitle }) => (
  <section className={classes.content}>
    {title ? <section className={classes.title}>{title}</section> : null}
    {subTitle ? <section className={classes.sub_title}>{subTitle}</section> : null}
  </section>
);
